var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveyCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7616 5.95976V21.3243C19.7616 22.9597 18.4358 24.2854 16.8005 24.2854H3.77165C2.13628 24.2854 0.810547 22.9597 0.810547 21.3243V3.55774C0.810547 1.92237 2.13628 0.596646 3.77165 0.596646H14.3985C14.5557 0.586674 14.7194 0.639096 14.8504 0.770103L19.5881 5.50786C19.7191 5.63887 19.7715 5.80253 19.7616 5.95976ZM13.8394 1.78109H3.77165C2.79042 1.78109 1.99499 2.57652 1.99499 3.55774V21.3243C1.99499 22.3056 2.79042 23.101 3.77165 23.101H16.8005C17.7817 23.101 18.5771 22.3056 18.5771 21.3243V6.51884H14.4316C14.1045 6.51884 13.8394 6.2537 13.8394 5.92662V1.78109ZM15.0238 2.61861V5.3344H17.7396L15.0238 2.61861Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6233 11.5619L6.95022 18.235L13.6233 11.5619ZM6.9502 11.5619L13.6233 18.235L6.9502 11.5619Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6233 11.5619L6.95022 18.235M6.9502 11.5619L13.6233 18.235",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyCancel);
export default __webpack_public_path__ + "static/media/survey_cancel.39a3d26f6bf2654c5e72e9c512e19ae7.svg";
export { ForwardRef as ReactComponent };